import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from '../services/accounts/auth.service';
import { RbacService } from '../services/accounts/rbac.service';
import { RbacMe } from '../models/rbac.model';

@Injectable({
  providedIn: 'root'
})
export class AdministrationGuard implements CanActivate {

  constructor(private auth: AuthService, private rbac: RbacService, private router: Router) {}

  canActivate(): Observable<boolean> | boolean {
    const cached = this.rbac.getSnapshot();
    if (cached) {
      return this.evaluate(cached);
    }

    if (!this.auth.requireAuthenticated()) {
      return false;
    }

    return this.rbac.fetchMe().pipe(
      map((me) => this.evaluate(me)),
      catchError((error) => {
        this.auth.handleRbacFetchError(error);
        return of(false);
      })
    );
  }

  private evaluate(me: RbacMe): boolean {
    const allowed = me.is_super_admin || me.roles.includes('company_admin');
    if (!allowed) {
      this.router.navigate(['/booking']);
    }
    return allowed;
  }
}
